import { Layout } from '@glu/core';
import FilterBadgesRowHeader from './filterBadgesRowHeader';
import AuxControl from './auxControl';

import template from './filterBadgesHeaderLayout.hbs';

export default Layout.extend({
  template,

  regions: {
    filterBadges: '.region-filter-badges',
    auxControl: '.region-aux-control'
  },

  onRender() {
    this.showFilterBadges();
    this.showAuxControl();
  },

  showFilterBadges() {
    this.filterBadges.show(new FilterBadgesRowHeader({
      columns: this.options.columns,
      masterCollection: this.options.masterCollection,
      filters: this.options.filterProc.filters
    }));
  },

  showAuxControl() {
    this.auxControl.show(new AuxControl({
      collection: this.options.masterCollection,
      filterProc: this.options.filterProc
    }));
  }
});
